import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {InventoriesModelService} from '../../../Models/Warehouse/Inventories/inventories-model.service';
import {StockFilters} from '../../../../Models/Warehouse/Stocks/stock-filters.model';
import {InventoryStockStoreForm} from '../../../../Models/Warehouse/Inventories/inventory-stock-store.model';
import {StockProductDto} from '../../../../Models/Warehouse/Stocks/stock.interface';
import {InventoryMovementDto} from '../../../../Models/Warehouse/Inventories/inventory.interface';

@Injectable({
  providedIn: 'root'
})
export class InventoriesApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: InventoriesModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener inventarios
   *
   */
  getInventories(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getInventarios', {}, 'post', true).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar el producto de inventario
   *
   */
  saveInventoryProduct(params: StockProductDto | InventoryMovementDto): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setProductInventario', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Abrir inventario
   *
   */
  public openInventory(params: StockFilters | null): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('openInventario', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar inventario
   *
   */
  public saveInventory(params: InventoryStockStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setInventarioNew', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Cerrar inventario
   *
   */
  public closeInventory(params: { id_inventario?: number, create_closing_inventory?: boolean }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('closeInventario', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }

}
